
interface SummaryCardProps {
  subtotal: number;
  discount: number;
  tip: number;
  total: number;
  onCheckout: (method: 'mpesa' | 'card' | 'free') => void;
  isLoading?: boolean;
}

export const SummaryCard = ({
  subtotal,
  discount,
  tip,
  total,
  onCheckout,
  isLoading = false
}: SummaryCardProps) => {
  const isFreeCheckout = total <= 0;
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm sticky top-4">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Order Summary</h2>
      
      {/* Summary Lines */}
      <div className="space-y-3 mb-6">
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Subtotal</span>
          <span className="text-gray-900">KES {subtotal.toLocaleString()}</span>
        </div>
        
        {discount > 0 && (
          <div className="flex justify-between text-sm">
            <span className="text-gray-600">Discount</span>
            <span className="text-emerald-600">-KES {discount.toLocaleString()}</span>
          </div>
        )}
        
        {tip > 0 && (
          <div className="flex justify-between text-sm">
            <span className="text-gray-600">Tip</span>
            <span className="text-gray-900">KES {tip.toLocaleString()}</span>
          </div>
        )}
        
        <hr className="border-gray-200" />
        
        <div className="flex justify-between">
          <span className="text-lg font-semibold text-gray-900">Total</span>
          <span className="text-lg font-bold text-gray-900">KES {total.toLocaleString()}</span>
        </div>
      </div>
      
      {/* Payment Buttons */}
      <div className="space-y-3 mb-6">
        {isFreeCheckout ? (
          <button
            onClick={() => onCheckout('free')}
            disabled={isLoading}
            className="w-full bg-emerald-600 text-white py-3 px-4 rounded-lg font-semibold hover:bg-emerald-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
          >
            {isLoading ? (
              <div className="flex items-center justify-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-loader-4-line animate-spin"></i>
                </div>
                Processing...
              </div>
            ) : (
              'Complete checkout'
            )}
          </button>
        ) : (
          <>
            <button
              onClick={() => onCheckout('mpesa')}
              disabled={isLoading}
              className="w-full bg-emerald-600 text-white py-3 px-4 rounded-lg font-semibold hover:bg-emerald-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
            >
              {isLoading ? (
                <div className="flex items-center justify-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-loader-4-line animate-spin"></i>
                  </div>
                  Processing...
                </div>
              ) : (
                'Checkout with MPESA'
              )}
            </button>
            
          </>
        )}
      </div>
      
      {/* Trust Row */}
      <div className="text-center space-y-2">
        <div className="flex items-center justify-center gap-4 text-xs text-gray-500">
          {isFreeCheckout ? (
            <span className="flex items-center gap-1">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-price-tag-3-line"></i>
              </div>
              No payment required
            </span>
          ) : (
            <span className="flex items-center gap-1">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-smartphone-line"></i>
              </div>
              M-Pesa
            </span>
          )}
          <span className="flex items-center gap-1">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-download-line"></i>
            </div>
            Instant access
          </span>
          <span className="flex items-center gap-1">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-shield-check-line"></i>
            </div>
            Secure downloads
          </span>
        </div>
        
        <p className="text-xs text-gray-500">
          {isFreeCheckout
            ? 'Instant access—downloads in your Library.'
            : 'Instant access after payment—downloads in your Library.'}
        </p>
        
<p className="text-xs text-gray-400">Need help? <a href="mailto:help@254tracks.com" className="text-emerald-600">Contact support</a></p>
      </div>
    </div>
  );
};
